/* La Manufacture Gourmande — décors dessinés générés à la volée (un univers par monde).
   Usage (Liquid) : {% render 'lmg-decor', u: 'mer' %} dans un conteneur .lmg-decor */
(function () {
  'use strict';
  var seed = 7;
  function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
  function U(a, b) { return a + (b - a) * rnd(); }
  function F(v) { return Math.abs(v) < 10 ? String(Math.round(v * 10) / 10) : String(Math.round(v)); }
  var PI = Math.PI, sin = Math.sin, cos = Math.cos;
  function P(d, x) { return '<path d="' + d + '"' + (x || '') + '/>'; }
  function C(cx, cy, r, x) { return '<circle cx="' + F(cx) + '" cy="' + F(cy) + '" r="' + F(r) + '"' + (x || '') + '/>'; }
  var FILL = ' class="fill"';
  function g(cls, inner, tx, ty, s, r, st) {
    var t = 'translate(' + F(tx || 0) + ' ' + F(ty || 0) + ')';
    if (r) t += ' rotate(' + F(r) + ')';
    if (s && s !== 1) t += ' scale(' + s + ')';
    return '<g transform="' + t + '"><g class="' + cls + '"' + (st ? ' style="' + st + '"' : '') + '>' + inner + '</g></g>';
  }
  function rep(n, f) { var o = ''; for (var i = 0; i < n; i++) o += f(i); return o; }
  function wobble(pts, amp) {
    var d = 'M' + F(pts[0][0]) + ',' + F(pts[0][1]);
    for (var i = 1; i < pts.length; i++) {
      var a = pts[i - 1], b = pts[i];
      d += ' Q' + F((a[0] + b[0]) / 2 + U(-amp, amp)) + ',' + F((a[1] + b[1]) / 2 + U(-amp, amp)) + ' ' + F(b[0]) + ',' + F(b[1]);
    }
    return d;
  }
  function wave(y, amp, wl, ph) {
    var d = '';
    for (var x = -1440; x <= 2880; x += 40) d += (d ? ' L' : 'M') + x + ',' + F(y + amp * sin((x / wl) * 2 * PI + ph));
    return d;
  }

  /* ---------- motifs ---------- */
  function fish() {
    return P('M0,0 C22,-26 70,-28 100,-4 C70,24 24,24 0,0 Z') + P('M98,-4 L132,-26 C126,-10 126,4 132,18 Z') +
      P('M40,-20 C50,-36 66,-34 72,-22') + P('M26,-12 C32,-4 32,6 26,12') +
      [44, 56, 68, 80].map(function (x) { return P('M' + x + ',-8 c6,4 6,12 0,16'); }).join('') + C(14, -4, 3.2, FILL);
  }
  function octopus() {
    var o = P('M-46,10 C-56,-60 56,-60 46,10 C40,26 -40,26 -46,10 Z') + C(-16, -6, 5) + C(16, -6, 5) + C(-16, -6, 1.6, FILL) + C(16, -6, 1.6, FILL);
    [-40, -20, 0, 20, 40].forEach(function (sx) {
      var k = sx < 0 ? -1 : 1;
      o += P('M' + sx + ',18 C' + (sx + k * 6) + ',60 ' + (sx - k * 30) + ',70 ' + (sx - k * 10) + ',104 C' + (sx + k * 6) + ',128 ' + (sx + k * 40) + ',118 ' + (sx + k * 30) + ',98 C' + (sx + k * 22) + ',86 ' + (sx + k * 8) + ',96 ' + (sx + k * 14) + ',106');
      for (var j = 0; j < 3; j++) o += C(sx - k * (4 + j * 3), 40 + j * 18, 2.4);
    });
    return o;
  }
  function langouste() {
    return P('M0,0 C10,-14 50,-16 70,-6 C90,4 120,0 150,8 C130,18 96,16 70,14 C46,12 12,16 0,0 Z') +
      [84, 100, 116, 132].map(function (x) { return P('M' + x + ',-8 C' + (x + 4) + ',0 ' + (x + 4) + ',8 ' + x + ',14'); }).join('') +
      P('M150,8 L176,-8 L172,8 L178,24 Z') + P('M2,-4 C-60,-60 -120,-40 -180,-90') + P('M4,2 C-50,-30 -110,-10 -170,-40') +
      [30, 44, 58, 72].map(function (x) { return P('M' + x + ',12 C' + (x - 6) + ',30 ' + (x - 14) + ',38 ' + (x - 22) + ',44'); }).join('') + C(10, -4, 2.6, FILL);
  }
  function crab() {
    var o = P('M-50,0 C-50,-34 50,-34 50,0 C50,22 -50,22 -50,0 Z') +
      P('M-46,-14 C-80,-30 -86,-60 -66,-74 C-60,-60 -70,-50 -58,-44 C-56,-58 -44,-66 -38,-56 C-42,-40 -46,-30 -40,-22') +
      P('M46,-14 C80,-30 86,-60 66,-74 C60,-60 70,-50 58,-44 C56,-58 44,-66 38,-56 C42,-40 46,-30 40,-22');
    [-1, 1].forEach(function (s) { [2, 10, 18].forEach(function (y) { o += P('M' + s * 44 + ',' + y + ' C' + s * 70 + ',' + (y + 4) + ' ' + s * 84 + ',' + (y + 18) + ' ' + s * 92 + ',' + (y + 34)); }); });
    return o + P('M-12,-26 L-14,-40') + P('M12,-26 L14,-40') + C(-14, -43, 4, FILL) + C(14, -43, 4, FILL);
  }
  function shell() {
    return P('M0,0 C-44,-6 -64,-50 -40,-82 C-20,-104 20,-104 40,-82 C64,-50 44,-6 0,0 Z') +
      rep(9, function (i) { var a = -0.62 + i * 0.155; return P('M0,0 L' + F(70 * sin(a)) + ',' + F(-96 * cos(a) * 0.95)); }) + P('M-14,0 L-20,12 L20,12 L14,0');
  }
  function seaweed(h) {
    h = h || 220;
    var d1 = 'M0,0', d2 = 'M14,0';
    for (var i = 0; i < 6; i++) {
      d1 += ' Q' + (i % 2 ? -18 : 18) + ',' + F(-(i * 2 + 1) * h / 12) + ' 0,' + F(-(i + 1) * h / 6);
      d2 += ' Q' + (14 + (i % 2 ? 16 : -16)) + ',' + F(-(i * 2 + 1) * h / 14) + ' 14,' + F(-(i + 1) * h / 7 * 0.9);
    }
    return P(d1) + P(d2) + [60, 130].map(function (y) { return P('M0,' + -y + ' c-26,-8 -34,-26 -30,-40 c14,6 26,22 30,40'); }).join('');
  }
  function bull() {
    return P('M-40,-40 C-80,-50 -110,-90 -96,-130 C-84,-104 -64,-82 -30,-70') + P('M40,-40 C80,-50 110,-90 96,-130 C84,-104 64,-82 30,-70') +
      P('M-42,-66 C-56,-30 -40,40 -24,70 C-12,92 12,92 24,70 C40,40 56,-30 42,-66 C20,-80 -20,-80 -42,-66 Z') +
      P('M-44,-56 C-74,-52 -86,-36 -78,-28 C-64,-30 -52,-40 -44,-44') + P('M44,-56 C74,-52 86,-36 78,-28 C64,-30 52,-40 44,-44') +
      P('M-24,54 C-26,78 26,78 24,54') + C(-10, 66, 3.6, FILL) + C(10, 66, 3.6, FILL) +
      P('M-28,-16 c6,-6 12,-6 16,0') + P('M12,-16 c6,-6 12,-6 16,0') + P('M-14,-74 c6,-12 10,-12 14,-2 c4,-10 10,-10 14,2');
  }
  function truffle() {
    var pts = [], n = 22;
    for (var i = 0; i <= n; i++) { var a = i / n * 2 * PI, r = 50 + (i % 2 ? 6 : -2) + U(-3, 3); pts.push([r * cos(a), r * 0.86 * sin(a)]); }
    return P(wobble(pts, 2)) + rep(16, function () { return C(U(-30, 30), U(-26, 26), 1.8, FILL); }) + P('M-20,-10 c10,8 30,6 36,-6');
  }
  function oliveBranch() {
    var leaf = P('M0,0 C14,-10 40,-10 58,0 C40,10 14,10 0,0 Z') + P('M4,0 L52,0'), olive = P('M0,0 C0,-12 20,-12 20,0 C20,12 0,12 0,0 Z');
    return P('M0,0 C40,-20 90,-30 160,-20 C200,-14 230,-4 260,10') +
      rep(6, function (i) { return g('', leaf, 30 + i * 38, -18 - 6 * sin(i), 1, i % 2 === 0 ? -38 : 30); }) + g('', olive, 120, 2, 1, 20) + g('', olive, 196, -4, 1, -15);
  }
  function cypress(h) {
    h = h || 170;
    var o = P('M0,0 C-18,-' + F(h * 0.3) + ' -16,-' + F(h * 0.7) + ' 0,-' + h + ' C16,-' + F(h * 0.7) + ' 18,-' + F(h * 0.3) + ' 0,0 Z') + P('M0,-10 L0,-' + F(h * 0.85));
    for (var y = Math.floor(h * 0.2); y < Math.floor(h * 0.8); y += 26) o += P('M0,-' + y + ' l-9,-14 M0,-' + y + ' l9,-14');
    return o;
  }
  function sun(r, n) {
    return C(0, 0, r) + rep(n, function (i) { var a = i * 2 * PI / n, R = r + (i % 2 ? 40 : 28); return P('M' + F((r + 14) * cos(a)) + ',' + F((r + 14) * sin(a)) + ' L' + F(R * cos(a)) + ',' + F(R * sin(a))); });
  }
  function hills() {
    var o = P('M-40,0 C120,-90 260,-120 420,-60 C520,-24 600,-100 760,-130 C900,-156 1020,-60 1160,-80 C1300,-100 1400,-40 1480,-30') +
      P('M-40,40 C160,-20 300,-10 460,10 C620,30 760,-40 920,-30 C1080,-20 1200,20 1480,0');
    for (var x = 40; x < 1400; x += 110) o += P('M' + x + ',' + F(-10 + 6 * sin(x / 90)) + ' q30,-8 60,0');
    return o;
  }
  function thyme() {
    var o = P('M0,0 C4,-40 -4,-90 6,-140');
    for (var y = 18; y < 140; y += 20) { var x = F(2 * sin(y / 20)); o += P('M' + x + ',-' + y + ' c-14,-4 -18,-12 -16,-18 c8,0 14,8 16,18 M' + x + ',-' + y + ' c14,-4 18,-12 16,-18 c-8,0 -14,8 -16,18'); }
    return o;
  }
  function basilLeaf() {
    return P('M0,0 C-30,-20 -40,-70 0,-110 C40,-70 30,-20 0,0 Z') + P('M0,-4 C2,-40 0,-70 0,-100') +
      /* nervures redimensionnées pour rester à l'intérieur du contour de la feuille */
      P('M0,-26 c-8,-6 -14,-14 -17,-22 M0,-26 c8,-6 14,-14 17,-22') +
      P('M0,-50 c-7,-6 -13,-13 -15.5,-20 M0,-50 c7,-6 13,-13 15.5,-20') +
      P('M0,-74 c-4,-5 -8,-11 -9.5,-16 M0,-74 c4,-5 8,-11 9.5,-16');
  }
  function basilSprig() {
    var o = P('M0,0 C-4,-60 6,-120 0,-200'), L = basilLeaf();
    [[50, -48], [60, 48], [110, -40], [120, 40], [170, -20], [176, 24]].forEach(function (v, i) { o += g('', L, 0, -v[0], Math.round((0.62 - i * 0.05) * 100) / 100, v[1]); });
    return o;
  }
  function tomato() {
    return P('M0,0 C-58,0 -70,-70 -30,-92 C-14,-100 14,-100 30,-92 C70,-70 58,0 0,0 Z') +
      rep(5, function (k) { var a = k * 2 * PI / 5 - PI / 2; return P('M0,-92 Q' + F(14 * cos(a)) + ',' + F(-96 + 10 * sin(a)) + ' ' + F(30 * cos(a)) + ',' + F(-92 + 16 * sin(a))); }) +
      P('M0,-92 C2,-104 -2,-112 4,-120') + P('M-34,-56 C-36,-40 -30,-26 -22,-18');
  }
  function cheese() { return P('M0,0 L150,-40 L150,10 L0,50 Z') + P('M0,0 L0,50') + P('M150,-40 L170,-20 L170,30 L150,10') + C(40, 20, 8) + C(90, 6, 6) + C(118, 22, 10) + C(66, 34, 4); }
  function chili() { return P('M0,0 C40,10 90,40 120,96 C86,70 40,44 -4,22 Z') + P('M0,0 C-10,-6 -14,-18 -8,-30') + P('M-6,10 C-20,0 -16,-14 -2,-12'); }
  function coconut() { return C(0, 0, 60) + C(0, 0, 44) + rep(13, function (k) { var a = k * 0.5; return P('M' + F(46 * cos(a)) + ',' + F(46 * sin(a)) + ' L' + F(58 * cos(a)) + ',' + F(58 * sin(a))); }); }
  function chickpea(r) {
    return P('M0,' + F(r) + ' C-' + F(r * 1.2) + ',' + F(r) + ' -' + F(r * 1.1) + ',-' + F(r * 0.9) + ' 0,-' + F(r) + ' C' + F(r * 0.6) + ',-' + F(r) + ' ' + F(r * 0.9) + ',-' + F(r * 0.6) + ' ' + F(r * 0.5) + ',-' + F(r * 1.25) +
      ' C' + F(r * 1.3) + ',-' + F(r * 0.6) + ' ' + F(r * 1.2) + ',' + F(r) + ' 0,' + F(r) + ' Z');
  }
  function chickpeaPlant() {
    var o = P('M0,0 C10,-60 -6,-120 8,-200'), pea = P('M0,0 c-6,-8 -2,-16 6,-14 c6,2 4,12 -6,14 Z'), i = 0;
    for (var y = 30; y < 190; y += 34, i++) {
      var s = i % 2 ? 1 : -1;
      o += P('M' + F(2 * sin(y)) + ',-' + y + ' c' + s * 20 + ',-6 ' + s * 34 + ',-14 ' + s * 44 + ',-30');
      for (var k = 0; k < 4; k++) o += g('', pea, s * (14 + k * 9), -y - 6 - k * 7, 1, s * 30);
    }
    return o + g('', P('M0,0 C10,-26 42,-30 54,-8 C40,6 16,10 0,0 Z') + P('M6,-4 C20,-12 36,-12 48,-8'), 10, -120, 1, -20);
  }
  function fries() {
    var stick = P('M-8,0 L-8,-120 Q0,-128 8,-120 L8,0 Z') + P('M-3,-110 L-3,-20');
    return [[-30, -14], [-10, -4], [10, 6], [30, 16], [0, 0]].map(function (v) { return g('', stick, v[0], 0, 1, v[1]); }).join('') + P('M-60,0 L60,0 L48,70 L-48,70 Z') + P('M-44,24 L44,24');
  }
  function lemon() {
    return P('M-56,0 C-56,-40 56,-40 56,0 C56,40 -56,40 -56,0 Z') + P('M-56,0 l-12,-4 M56,0 l12,4') +
      rep(8, function (k) { var a = k * PI / 4; return P('M0,0 L' + F(40 * cos(a)) + ',' + F(28 * sin(a))); }) + C(0, 0, 6);
  }
  function blossom() {
    var petal = P('M0,0 C-16,-14 -14,-40 0,-48 C14,-40 16,-14 0,0 Z');
    return rep(5, function (k) { return g('', petal, 0, 0, 1, k * 72); }) + C(0, 0, 8) + rep(6, function (k) { var a = k * PI / 3; return P('M0,0 L' + F(18 * cos(a)) + ',' + F(18 * sin(a))); });
  }
  function licorice() { var o = P('M-8,0 L-8,-130 Q0,-138 8,-130 L8,0 Q0,8 -8,0 Z'); for (var y = 10; y < 126; y += 14) o += P('M-8,-' + y + ' L8,-' + (y + 8)); return o; }
  function ravioli() {
    var e = [], n = 9, s, i, t;
    for (s = 0; s < 4; s++) for (i = 0; i < n; i++) { t = i / n; e.push(s === 0 ? [-60 + 120 * t, -60] : s === 1 ? [60, -60 + 120 * t] : s === 2 ? [60 - 120 * t, 60] : [-60, 60 - 120 * t]); }
    e.push(e[0]);
    var d = 'M' + F(e[0][0]) + ',' + F(e[0][1]);
    for (i = 1; i < e.length; i++) d += ' Q' + F((e[i - 1][0] + e[i][0]) / 2 * 1.08) + ',' + F((e[i - 1][1] + e[i][1]) / 2 * 1.08) + ' ' + F(e[i][0]) + ',' + F(e[i][1]);
    var f = '';
    for (var x = -44; x < 50; x += 12) f += P('M' + x + ',-52 L' + x + ',-44 M' + x + ',44 L' + x + ',52') + P('M-52,' + x + ' L-44,' + x + ' M44,' + x + ' L52,' + x);
    return P(d) + P('M-34,0 C-34,-44 34,-44 34,0 C34,44 -34,44 -34,0 Z') + f;
  }
  /* Les Canailles : bol de billes de panisse (même dessin que le pictogramme de la famille) */
  function canaillesBowl() {
    var o = P('M-80,16 L80,16 C76,60 44,80 0,80 C-44,80 -76,60 -80,16 Z');
    [[-42, -6], [0, -6], [42, -6], [-21, -42], [21, -42], [0, -78]].forEach(function (b) {
      o += C(b[0], b[1], 17) + P('M' + F(b[0] - 9) + ',' + F(b[1] - 4) + ' q3,-7 10,-8');
    });
    return o;
  }
  /* Les Canaillous : coupe de billes sucrées (même dessin que le pictogramme de la famille) */
  function canaillousCup() {
    var o = P('M-72,4 L72,4 C70,44 38,62 0,62 C-38,62 -70,44 -72,4 Z') + P('M0,62 L0,82 M-30,86 L30,86');
    [[-21, -16], [21, -16], [0, -52]].forEach(function (b) {
      o += C(b[0], b[1], 17) + C(b[0] - 6, b[1] - 5, 1.6, FILL) + C(b[0] + 5, b[1] + 2, 1.4, FILL) + C(b[0] + 1, b[1] - 9, 1.2, FILL);
    });
    return o + P('M56,-72 L56,-44 M42,-58 L70,-58') + P('M-56,-60 L-56,-46 M-63,-53 L-49,-53');
  }
  /* Maître Pastier : épi de blé, rouleau, roulette à raviolis */
  function wheat() {
    var o = P('M0,0 C2,-50 0,-100 4,-150');
    for (var i = 0; i < 6; i++) {
      var y = 46 + i * 18, x = F(1 + i * 0.4);
      o += P('M' + x + ',-' + y + ' c-12,-4 -18,-14 -16,-26 c9,4 15,13 16,26 Z') + P('M' + x + ',-' + y + ' c12,-4 18,-14 16,-26 c-9,4 -15,13 -16,26 Z');
    }
    return o + P('M4,-150 c-6,-10 -6,-20 -2,-30 c6,8 6,20 2,30 Z') + P('M-2,-160 l-10,-26 M8,-160 l10,-26');
  }
  function rollingPin() {
    return P('M-60,-10 L60,-10 Q72,-10 72,0 Q72,10 60,10 L-60,10 Q-72,10 -72,0 Q-72,-10 -60,-10 Z') + P('M-72,0 L-100,0 M72,0 L100,0') + P('M-44,-10 L-44,10 M44,-10 L44,10');
  }
  function pastryWheel() {
    var n = 12, r = 22, d = '';
    for (var i = 0; i <= n; i++) {
      var a = i * 2 * PI / n, x = r * cos(a), y = r * sin(a);
      if (!i) { d = 'M' + F(x) + ',' + F(y); continue; }
      var am = (i - 0.5) * 2 * PI / n;
      d += ' Q' + F((r + 5) * cos(am)) + ',' + F((r + 5) * sin(am)) + ' ' + F(x) + ',' + F(y);
    }
    return P(d + ' Z') + C(0, 0, 4, FILL) + P('M0,0 L28,-32') + P('M28,-32 L50,-58', ' stroke-width="6"');
  }
  function bubbles() { return [[0, 0, 9], [16, -30, 6], [-6, -58, 11], [10, -92, 5], [-10, -120, 7]].map(function (b) { return C(b[0], b[1], b[2]); }).join(''); }

  /* ---------- scènes ---------- */
  var cache = {};
  function scene(u) {
    if (cache[u]) return cache[u];
    seed = 7 + u.length * 13;
    var L = [];
    if (u === 'mer') {
      [[640, 14, 360, 's1'], [700, 18, 420, 's2'], [770, 12, 300, 's3'], [840, 20, 480, 's4']].forEach(function (w, i) { L.push('<g class="swell ' + w[3] + '">' + P(wave(w[0], w[1], w[2], i)) + '</g>'); });
      L.push(g('swim f1', fish(), 180, 260, 1.15), g('swim f2', fish(), 1180, 180, 0.8, 180), g('swim f3', fish(), 980, 470, 0.6, -6),
        g('bob', octopus(), 1250, 560, 1.1), g('float', langouste(), 380, 520, 0.9, -8), g('float d2', crab(), 760, 760, 0.8),
        g('sway', seaweed(), 80, 900, 1.2), g('sway d2', seaweed(180), 1380, 900, 1), g('float d3', shell(), 600, 300, 0.7, 12),
        g('rise', bubbles(), 300, 420, 1), g('rise d2', bubbles(), 1100, 420, 0.8), g('rise d3', bubbles(), 860, 300, 0.6));
    } else if (u === 'terre') {
      L.push(g('spin-slow', sun(56, 16), 1220, 170, 1), g('hill', hills(), 0, 820, 1), g('hill d2', hills(), 0, 900, 1),
        g('sway', cypress(), 210, 760, 1), g('sway d2', cypress(140), 250, 770, 1), g('sway d3', cypress(200), 1120, 740, 1),
        g('float', bull(), 1180, 470, 1.15), g('float d2', truffle(), 300, 330, 1.2, -10), g('float d3', truffle(), 820, 220, 0.7, 20),
        g('sway', oliveBranch(), 520, 600, 1.1, -10), g('sway d2', thyme(), 60, 520, 1.2, 10), g('sway d3', thyme(), 1400, 420, 1, -12));
    } else if (u === 'vege') {
      L.push(g('sway', basilSprig(), 140, 860, 1.6, 8), g('sway d2', basilSprig(), 1330, 900, 1.3, -10), g('float', tomato(), 1040, 330, 1.2, 8),
        g('float d2', tomato(), 1210, 600, 0.75, -14), g('float d3', cheese(), 330, 380, 1, -8), g('bob', chili(), 760, 170, 0.9, 20),
        g('spin-slow', coconut(), 560, 690, 0.9), g('float d2', basilLeaf(), 860, 560, 0.9, 40), g('float d3', basilLeaf(), 420, 170, 0.6, -30));
      for (var i = 0; i < 14; i++) L.push(g('twinkle', C(0, 0, U(2, 5), FILL), U(40, 1400), U(60, 840), 1, 0, 'animation-delay:' + U(0, 4).toFixed(1) + 's'));
    } else if (u === 'panisse') {
      L.push(g('spin-slow', sun(70, 24), 1200, 190, 1), g('sway', chickpeaPlant(), 120, 900, 1.5, 6), g('sway d2', chickpeaPlant(), 1350, 900, 1.2, -8),
        g('float', fries(), 800, 560, 1.2, 8), g('bob', canaillesBowl(), 1110, 610, 0.95, -6), g('float d3', canaillousCup(), 330, 600, 1.05, 8),
        g('float d2', lemon(), 360, 300, 1, -20), g('spin-slow', blossom(), 700, 200, 1), g('float d3', licorice(), 560, 790, 0.9, 30));
      for (var j = 0; j < 10; j++) L.push(g('bob', chickpea(U(10, 18)), U(260, 1300), U(380, 860), 1, U(0, 360), 'animation-delay:' + U(0, 3).toFixed(1) + 's'));
    } else if (u === 'pastier') {
      L.push(g('spin-slow', ravioli(), 1190, 250, 1.3, 12), g('float', ravioli(), 250, 650, 0.8, -18), g('float d2', ravioli(), 930, 730, 0.55, 30),
        g('sway', wheat(), 120, 890, 1.5, 6), g('sway d2', wheat(), 1360, 900, 1.3, -8), g('float d3', rollingPin(), 640, 200, 1.1, -12),
        g('bob', pastryWheel(), 560, 640, 1.3), g('float d2', chickpea(16), 1010, 470, 1), g('float d3', chickpea(12), 380, 300, 1));
    } else {
      L.push(g('spin-slow', ravioli(), 1180, 260, 1.4, 12), g('float', ravioli(), 230, 640, 0.9, -18), g('float d2', ravioli(), 980, 700, 0.6, 30),
        g('sway', oliveBranch(), 80, 220, 1, 10), g('float d3', chickpea(18), 720, 140, 1), g('float d2', truffle(), 520, 760, 0.6),
        g('swim f2', fish(), 1260, 560, 0.6), g('sway d2', basilLeaf(), 1400, 820, 0.8, -20));
    }
    return (cache[u] = '<svg class="lmg-decor__svg" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' + L.join('') + '</svg>');
  }
  function paint(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.lmg-scene[data-scene]'), function (el) {
      el.outerHTML = scene(el.getAttribute('data-scene'));
    });
  }
  window.LMGDecor = { paint: paint, scene: scene };
  paint();
  document.addEventListener('shopify:section:load', function (e) { paint(e.target); });
})();